import { MonitoringAvailabilityZoneInfo } from "../status/monitoring-status.view-model";
import { Channel } from "../../../domain/channel";
import { UserService } from "../../../domain/user-service";
import { ChannelRepository } from "../../../domain/channel-repository";
import { ReportsService } from "../../../services/reports.service";
import { TargetChartPopupViewModel } from "./target-details-popup/target-details-popup.view-model";
import { IMonitoringRepository } from "../../../domain/monitoring/monitoring-repository";
import { ChannelTargetData } from "../../../domain/monitoring/channel-target.data";

export class MonitoringTargetsPageViewModel {
  public targets: ChannelTargetData[] = [];
  public selectedAvailabilityZoneIds: number[] = [];
  public selectedAvailabilityZones: MonitoringAvailabilityZoneInfo[] = [];

  public inputChartPopupVM: TargetChartPopupViewModel;

  public selectedChannelIds: number[] = [];
  public selectedChannels: Channel[] = [];

  public allAvailabilityZones: MonitoringAvailabilityZoneInfo[] = [];
  public allChannels: Channel[] = [];
  public visibleChannels: Channel[] = [];
  public selectedTargetTypes: string[] = [];
  public sortTargetsByBitrateAsc;
  public sortTargetsByChannelNameAsc;

  private _refreshingTargets = false;
  private _refreshTimeIntervalSecs = 10;
  private _refreshIntervalId;

  constructor(
    private _userService: UserService,
    private _channelRepository: ChannelRepository,
    private _reportService: ReportsService,
    private _monitoringRepository: IMonitoringRepository,
  ) {}
  public async onInit() {
    this.allAvailabilityZones = this._userService
      .getCurrentUser()
      .channelAvailabilityZones.filter((z) => z.isActive)
      .map(
        (z) =>
          new MonitoringAvailabilityZoneInfo(z.id, z.displayName, z.htmlColor),
      );
    this.allChannels = (
      await this._channelRepository.getAllChannels(null, true)
    ).sort((a, b) => this._sortByAlphabet(b.name, a.name));

    this._refreshIntervalId = setInterval(async () => {
      await this.refreshButtonClicked();
    }, this._refreshTimeIntervalSecs * 1000);
  }
  public showInputDetailsPopup(input: ChannelTargetData) {
    this.inputChartPopupVM = new TargetChartPopupViewModel(
      input,
      this._monitoringRepository,
      "47vw",
      "",
    );
    this.inputChartPopupVM.showWindow();

    this.inputChartPopupVM.state = "ready";
    this.inputChartPopupVM.showChannelTargetChart();
  }

  public onAvailabilityZoneChanged() {
    this.selectedAvailabilityZones = this.allAvailabilityZones.filter((z) =>
      this.selectedAvailabilityZoneIds.includes(z.id),
    );
    this.visibleChannels = this.allChannels.filter(
      this._checkIfChannelBelongsToAZ.bind(this),
    );
    //refresh the table
  }

  private _checkIfChannelBelongsToAZ(channel: Channel): boolean {
    for (let i = 0; i < channel._availabilityZoneIds.length; i++) {
      const channelAZId = channel._availabilityZoneIds[i];
      if (this.selectedAvailabilityZoneIds.includes(channelAZId)) {
        return true;
      }
    }

    return false;
  }
  public async onChannelFilterChanged() {
    this.selectedChannels = this.allChannels.filter((z) =>
      this.selectedChannelIds.includes(z.id),
    );

    //refresh the table
    await this.refreshTargets();
  }

  public async onTargetsFilterChanged() {
    //refresh the table
    await this.refreshTargets();
  }

  public onDestroy() {
    clearInterval(this._refreshIntervalId);
  }

  public async sortTargetsByBitrate() {
    this.sortTargetsByChannelNameAsc = undefined;
    this.sortTargetsByBitrateAsc = !this.sortTargetsByBitrateAsc;
    await this.refreshTargets(this._sortByBitrate.bind(this));
  }

  public async sortTargetsByChannelName() {
    this.sortTargetsByBitrateAsc = undefined;
    this.sortTargetsByChannelNameAsc = !this.sortTargetsByChannelNameAsc;
    await this.refreshTargets(this._sortByAlphabet.bind(this));
  }
  public async refreshButtonClicked() {
    let sortFunc = undefined;
    if (this.sortTargetsByChannelNameAsc !== undefined) {
      sortFunc = this._sortByAlphabet.bind(this);
    } else if (this.sortTargetsByBitrateAsc !== undefined) {
      sortFunc = this._sortByBitrate.bind(this);
    }
    await this.refreshTargets(sortFunc);
  }

  public async refreshTargets(sortFunc?: (a, b) => number) {
    if (this._refreshingTargets === false) {
      this._refreshingTargets = true;
      const targetsResponse = await this._reportService.getChannelTargetsReport(
        this.selectedChannelIds,
        this.selectedAvailabilityZoneIds,
      );
      this.targets = targetsResponse
        .map(
          (r) =>
            new ChannelTargetData(
              r.Id,
              r.Status,
              r.Target,
              r.ChannelName,
              r.PlatformId,
              r.AvailabilityZoneId,
              r.AvailabilityZoneName,
              r.Type,
              r.Bitrate,
              r.Uptime,
            ),
        )
        .filter(
          (r) =>
            this.selectedTargetTypes.length === 0 ||
            this.selectedTargetTypes.includes(r.type),
        );
      if (sortFunc) {
        this.targets = this.targets.sort((a, b) =>
          sortFunc(a.channelName, b.channelName),
        );
      }

      this._refreshingTargets = false;
    }
  }

  private _sortByBitrate(a, b) {
    let result = 0;
    if (a.bitrate < b.bitrate) {
      result = 1;
    } else if (a.bitrate > b.bitrate) {
      result = -1;
    }

    if (this.sortTargetsByBitrateAsc) {
      result = result * -1;
    }
    return result;
  }
  private _sortByAlphabet(a, b) {
    let result = 0;
    result = b.localeCompare(a);

    if (this.sortTargetsByChannelNameAsc) {
      result = result * -1;
    }
    return result;
  }

  public static LastState: MonitoringTargetsPageViewModel;
}
